<template>
    <b-modal ref="profile_modal" size="lg" bodyClass="p-0" v-bind:no-close-on-backdrop=true :hide-header=true v-model="is_show_modal" :dialogClass=dialog_class_draw>
        
        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        
        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 v-if="article.id > 0">
                    <span class="fw-300">ID:{{this.article.id}} | {{this.article.title}}</span>
                </h2>
                
                <h2 v-else>
                    -
                </h2>
                
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>
            
            <div class="panel-container show">
                <div class="panel-content">
                    <div class="body_instr" v-html="article.text"></div>
                </div>
            </div>
            <!--FOOTER -->
        </div>
        
        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <button type="button" v-on:click="close_mod" class="btn btn-secondary waves-effect waves-themed">
                    Закрити
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>

export default {
    name: "instruction_modal",
    components : {
    
    },
    data() {
        return  {
            is_show_modal : false,
            article: {
                id : 0,
                title : "",
                "text" : ""
            },
        }
    },
    
    created() {
        EventBus.$on("show_instruction",this.show_instruction);
    },
    
    methods : {
        
        show_instruction(article) {
            this.article = article;
            this.is_show_modal = true;
        },
        
        close_mod() {
            this.close();
        },
        
        close() {
            this.article = {
                id : 0,
                title : "",
                "text" : ""
            };
            //	this.tabs = [];
            this.is_show_modal = false;
            
        },
        
        
    },
    
    
    computed : {
    
        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }
            
            return "modal-dialog-left modal-lg";
        },
        
    }
}
</script>

<style scoped>

</style>
